'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var colorPalette = require('./color-palette-14d554dc.js');

var ThemeNames = /*#__PURE__*/function (ThemeNames) {
  ThemeNames["White"] = "white";
  ThemeNames["Light"] = "light";
  ThemeNames["Midtone"] = "midtone";
  ThemeNames["Dark"] = "dark";
  return ThemeNames;
}({});
var SizeNames = /*#__PURE__*/function (SizeNames) {
  SizeNames["Small"] = "small";
  SizeNames["Default"] = "default";
  SizeNames["Large"] = "large";
  return SizeNames;
}({});

var linkTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, ThemeNames.White, {
  linkFontColor: colorPalette.WALDEN_100,
  linkOutlineColor: colorPalette.WALDEN_100,
  linkIconColor: colorPalette.WALDEN_100,
  linkHoverBackgroundColor: colorPalette.MYSTIC_40
}), ThemeNames.Light, {
  linkFontColor: colorPalette.WALDEN_100,
  linkOutlineColor: colorPalette.WALDEN_100,
  linkIconColor: colorPalette.WALDEN_100,
  linkHoverBackgroundColor: colorPalette.MYSTIC_40
}), ThemeNames.Midtone, {
  linkFontColor: colorPalette.ATLANTIC_90,
  linkOutlineColor: colorPalette.ATLANTIC_90,
  linkIconColor: colorPalette.ATLANTIC_90,
  linkHoverBackgroundColor: colorPalette.WHITE_50
}), ThemeNames.Dark, {
  linkFontColor: colorPalette.MYSTIC_80,
  linkOutlineColor: colorPalette.MYSTIC_80,
  linkIconColor: colorPalette.MYSTIC_80,
  linkHoverBackgroundColor: colorPalette.WHITE_20
});
var underlineLinkTheme = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, ThemeNames.White, {
  linkFontColor: colorPalette.WALDEN_100,
  linkUnderlineColor: colorPalette.WALDEN_100,
  linkHoverBackgroundColor: colorPalette.MYSTIC_40,
  linkOutlineColor: colorPalette.WALDEN_100
}), ThemeNames.Light, {
  linkFontColor: colorPalette.WALDEN_100,
  linkUnderlineColor: colorPalette.WALDEN_100,
  linkHoverBackgroundColor: colorPalette.MYSTIC_40,
  linkOutlineColor: colorPalette.WALDEN_100
}), ThemeNames.Midtone, {
  linkFontColor: colorPalette.ATLANTIC_90,
  linkUnderlineColor: colorPalette.ATLANTIC_90,
  linkHoverBackgroundColor: colorPalette.WHITE_50,
  linkOutlineColor: colorPalette.ATLANTIC_90
}), ThemeNames.Dark, {
  linkFontColor: colorPalette.MYSTIC_80,
  linkUnderlineColor: colorPalette.MYSTIC_80,
  linkHoverBackgroundColor: colorPalette.WHITE_20,
  linkOutlineColor: colorPalette.MYSTIC_80
});
var iconLinkSizes = _rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty(_rollupPluginBabelHelpers._defineProperty({}, SizeNames.Small, {
  linkSize: '1rem'
}), SizeNames.Default, {
  linkSize: '1.25rem'
}), SizeNames.Large, {
  linkSize: '1.25rem'
});

exports.SizeNames = SizeNames;
exports.ThemeNames = ThemeNames;
exports.iconLinkSizes = iconLinkSizes;
exports.linkTheme = linkTheme;
exports.underlineLinkTheme = underlineLinkTheme;
//# sourceMappingURL=theme-aad7ebc2.js.map
